import {Component, OnInit} from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';
import {NotificationsService} from 'angular2-notifications';
import {ColDef, ColumnApi, GridApi, GridOptions} from 'ag-grid-community';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {ImportFieldFormatType} from '../../../app/shared/enums/import-field-format-type.enum';
import {GridRowSelection} from 'gelios-ng-admin-components';

@Component({
  selector: 'app-gelios-import-field',
  templateUrl: './gelios-import-field.component.html',
  styleUrls: ['./gelios-import-field.component.scss']
})
export class GeliosImportFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  rowData: Array<any> = null;
  fileName = '';
  gridApi: GridApi;
  gridColumnApi: ColumnApi;

  colDef: ColDef[] = [
    {
      headerName: 'ID',
      field: 'id',
      checkboxSelection: true,
      headerCheckboxSelection: true,
      width: 100
    },
  ];
  private file: any;

  constructor(
    protected translateService: TranslateService,
    protected notif: NotificationsService,
    protected http: HttpClient,
  ) {
    super(translateService);
  }

  get gridOptions(): GridOptions {
    return {
      columnDefs: this.colDef,
      rowModelType: 'clientSide',
      rowSelection: GridRowSelection.MULTIPLE,
      rowMultiSelectWithClick: true,
      getRowNodeId: this.getRowNodeId,
      enableColResize: true,
      enableSorting: true,
    };
  }

  onSelectionChanged(data) {
    const result = [];
    let requestField = 'id';
    if (this.reflexiveField.importFieldConfig
      && this.reflexiveField.importFieldConfig.requestConfig
      && this.reflexiveField.importFieldConfig.requestConfig.requestField) {
      requestField = this.reflexiveField.importFieldConfig.requestConfig.requestField;
    }
    data.api.getSelectedRows().map(el => result.push(el[requestField]));
    this.formGroup.controls[this.fieldName].setValue(result);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getRowNodeId(data) {
    return data.id;
  }

  fileInputChanged(e: any) {
    this.fileName = e.target.files[0].name;
    this.file = e.target.files[0];

    if (!this.file) {
      return;
    }

    const fileReader = new FileReader();

    switch (this.format()) {
      case ImportFieldFormatType.FILE_TYPE_TXT:
        this.readFileAsTextFile(fileReader);
        break;

      case ImportFieldFormatType.FILE_TYPE_HTML:
        this.readFileAsHtml(fileReader);
        break;
    }
  }

  readFileAsTextFile(fileReader: FileReader) {
    fileReader.onload = () => {
      const text = fileReader.result.toString().trim();
      const fileReaderResult = text
        .split(/\r?\n|\r/)
        .map(line => line.trim())
        .filter(line => line.length > 0)
        .join(',');
      if (fileReaderResult && this.reflexiveField.importFieldConfig.requestConfig) {
        this.fetchItems(fileReaderResult);
      } else {
        const dataArray = fileReaderResult.split(',').map(item => item.trim());
        this.formGroup.controls[this.fieldName].setValue(dataArray);
      }
    };
    fileReader.readAsText(this.file);
  }

  fetchItems(data: string) {
    const notification = this.notif.info(this.translateService.instant('Please wait') + '...', '', {timeOut: 0});
    const requestConfig = this.reflexiveField.importFieldConfig.requestConfig;
    let params = new HttpParams()
      .append('per-page', '5000')
      .append('fields', requestConfig.fields)
      .append(`${requestConfig.searchModelName}[${requestConfig.searchField}]`
        , data.toString());
    if (requestConfig.expand) {
      params = params.append('expand', requestConfig.expand);
    }
    return this.http.get(
      environment.apiBasepoint + requestConfig.modelName,
      {params: params}
    ).pipe(
      catchError(
        (response) => {
          this.notif.remove(notification.id);
          switch (response.status) {
            case 500:
              this.notif.error(this.translateService.instant('Server error'));
              break;
            default:
              this.notif.error(this.translateService.instant('Unknown server error'));
          }
          return of([]);
        }
      )
    ).subscribe((result: Array<any>) => {
      this.notif.remove(notification.id);
      this.notif.success(this.translate.instant('Success') + '!');
      this.rowData = result;
    });
  }

  readFileAsHtml(fileReader: FileReader) {
    fileReader.onload = () => {
      const html = fileReader.result.toString();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, ImportFieldFormatType.FILE_TYPE_HTML);

      this.formGroup.controls[this.fieldName].setValue(html);
    };

    fileReader.readAsText(this.file);
  }

  format() {
    return this.reflexiveField.importFieldConfig && this.reflexiveField.importFieldConfig.format ?
      this.reflexiveField.importFieldConfig.format : ImportFieldFormatType.FILE_TYPE_TXT;
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.reflexiveField
      && this.reflexiveField.importFieldConfig
      && this.reflexiveField.importFieldConfig.requestConfig
      && this.reflexiveField.importFieldConfig.requestConfig.gridColumnsConfig
      && this.reflexiveField.importFieldConfig.requestConfig.gridColumnsConfig.length > 0
    ) {
      this.reflexiveField.importFieldConfig.requestConfig.gridColumnsConfig.forEach(item => {
        this.colDef.push(
          {
            headerName: this.translateService.instant(item.label),
            field: item.field,
          },
        );
      });
    }
  }
}
